import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import Login from "../features/authentication/login";
import ForgotPassword from "../features/authentication/forgotPassword";
import LandingPage from "../pages/Landing";
import About from "../pages/About";
import DoctorHomePage from "../pages/DoctorHomePage";
import AuthRoute from "./AuthRoute";
import Appointments from "../pages/Appointments";
import ProfilePage from "../pages/ProfilePage";
import PatientsPage from "../pages/PatientsPage";
import PatientPage from "../pages/PatientPage";
import PatientAppointmentDetailsPage from "../pages/PatientAppointmentDetailsPage";
import AppointmentDetails from "../pages/AppointmentDetails";
import Meet from "../pages/Meet";
import PostDetailPage from "../pages/PostDetailPage";
import ContactInfoPage from "../pages/ContactInfoPage";
import AvailabilityPage from "../pages/AvailabilityPage";
import ClinicAddressPage from "../pages/ClinicAddressPage";
import MedicalLicensePage from "../pages/MedicalLicensePage";
import NotificationsPage from "../pages/NotificationsPage";
import HelpPage from "../pages/HelpPage";
import SignupRouteGuard from "../features/authentication/signup/SignupRouteGuard";
import AppointmentRequestPage from "../pages/AppointmentRequestPage";
import AdmissionsPage from "../pages/AdmissionsPage";
import AdmissionsRouteGuard from "./AdmissionsRouteGuard";
import { Suspense } from "react";
import AdmissionDetailPage from "../pages/AdmissionDetailPage";

export default function AppRouter() {
  return (
    <Router>
      <Routes>
        {/* // public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignupRouteGuard />} />
        <Route path="/forgotPassword" element={<ForgotPassword />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/get-appointment" element={<AppointmentRequestPage />} />

        <Route
          path="/reset-password"
          element={<ForgotPassword stepFromRoute={3} />}
        />

        <Route path="/notifications" element={<NotificationsPage />} />
        {/* // Protected routes */}
        <Route element={<AuthRoute />}>
          <Route path="/doctor" element={<DoctorHomePage />} />
          <Route path="appointments" element={<Appointments />} />
          <Route path="profile" element={<ProfilePage />} />
          <Route path="patients" element={<PatientsPage />} />
          <Route path="patients/:id" element={<PatientPage />} />
          <Route
            path="patients/:patientId/appointments/:appointmentId"
            element={<PatientAppointmentDetailsPage />}
          />
          <Route
            path="patients/:patientId/appointments/:appointmentId/details"
            element={<AppointmentDetails />}
          />
          <Route path="meet" element={<Meet />} />
          <Route
            path="meet/:authorId/posts/:postId"
            element={<PostDetailPage />}
          />
          <Route
            path="/admissions"
            element={
              <AdmissionsRouteGuard>
                <Suspense fallback={null}>
                  <AdmissionsPage />
                </Suspense>
              </AdmissionsRouteGuard>
            }
          />

          <Route path="/admissions/:id" element={<AdmissionDetailPage />} />

          <Route
            path="profile/contact-information"
            element={<ContactInfoPage />}
          />
          <Route path="profile/availability" element={<AvailabilityPage />} />
          <Route
            path="profile/clinic-address"
            element={<ClinicAddressPage />}
          />
          <Route
            path="profile/medical-license"
            element={<MedicalLicensePage />}
          />
        </Route>
      </Routes>
    </Router>
  );
}
